import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { EncryptDecryptService } from 'src/app/services/services.index';

import { UserService } from '../services/services.index';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: UserService,private encryptDecryptService: EncryptDecryptService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(catchError(err => {
      if ([401, 403].indexOf(err.status) !== -1) {
      }
      const error = err.message || err.statusText;
      return throwError(err);
    }));
  }
}
